module.exports = __webpack_public_path__ + "img/02.bc770314.jpg";